import { useSyncExternalStore } from 'react';
import {
  readShownTableSlots,
  readStripSlotsInUse,
  type ShownTableSlots,
  subscribeShownTableSlots
} from 'utils/tableCapacity';

/**
 * Read what the mounted Current Tables strip (useActiveTables) publishes,
 * without deriving the strip again — for surfaces that only need the strip's
 * numbers, like TournamentDetails' Observe button (EN-11131).
 */

/** The slots the strip counts as in use (what its "+" hides at); 0 with no strip. */
export const useStripSlotsInUse = (): number =>
  useSyncExternalStore(subscribeShownTableSlots, readStripSlotsInUse, readStripSlotsInUse);

/** The cards the strip shows (each holds a slot); null with no strip. */
export const useStripShownSlots = (): ShownTableSlots | null =>
  useSyncExternalStore(subscribeShownTableSlots, readShownTableSlots, readShownTableSlots);
